import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-334da2dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "developer-mode"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Developer Mode", -1))
const _hoisted_3 = {
  key: 1,
  id: "staff-mode"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Staff Mode", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#main",
  class: "skip-link"
}, "Skip to content", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_simple_modal = _resolveComponent("simple-modal")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isDeveloper)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_simple_modal, {
            "button-label": "More info",
            "modal-heading": "Staff mode",
            message: _ctx.staffInfoMessage
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDonotfollow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_simple_modal, {
            "button-label": "More info",
            "modal-heading": "Staff mode",
            message: _ctx.staffInfoMessage
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createVNode(_component_router_view)
  ], 64))
}